import { createReducers, createActions, request } from '../../../utils/';
import { combineReducers } from 'redux';
import Urls from '../../../../config/index';
import { message } from 'antd';
const { MonitorUrl } = Urls;

const path = name => `app/pages/thirdParty/${name}`;
const models = {
    list: {
        data: [],
        handlers: {
            get(state, action) {
                return action.payload;
            },
            add(state, action) {
                return [...action.payload, ...state];
            },
            del(state, action) {
                return state.filter(item => item._id !== action.payload);
            },
            update(state, action) {
                return state.map(item => (item._id === action.payload._id ? action.payload : item));
            },
        },
    },
    listAll: {
        data: [],
        handlers: {
            getAll(state, action) {
                return action.payload;
            },
        },
    },
    transferData: {
        data: {
            selectedRowKeys: [],
        },
        handlers: {
            getTransferData(state, action) {
                return {...state, ...action.payload};
            },
        },
    },
    pagination: {
        data: {
            current: 1,
            total: 0,
            pageSize: 10,
        },
        handlers: {
            changePagination(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    searchValues: {
        data: {},
        handlers: {
            changeSearchValues(state, action) {
                return action.payload;
            },
        },
    },
    uiStatus: {
        data: {
            isLoading: false,
            isUpdateShow: false,
            isSendCommend: false,
        },
        handlers: {
            changeUiStatus(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    currentSelectId: {
        data: '',
        handlers: {
            changeCurrentSelectId(state, action) {
                return action.payload;
            },
        },
    },
};

export const actions = createActions(models, path);

export default combineReducers(createReducers(models, path));

const formatGetParams = getState => {
    const state = getState().thirdParty;
    const searchValue = state.searchValues || {};

    const params = {
        ...searchValue,
        page: state.pagination.current,
        pageSize: state.pagination.pageSize,
    };
    let temp = [];
    for (let key in params) {
        if (params[key]) {
            temp.push(`${key}=${params[key]}`);
        }
    }
    temp = temp.join('&');
    return temp;

};

/**
 * 获取订单列表数据
 */
export const asyncGet = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoading: true,
                }),
            );
            // 下面的请求和结果返回需要根据接口来实现
            let result = await request(`${MonitorUrl.thirdParty}?${formatGetParams(getState)}` , 'GET');
            let { list } = result;
            dispatch(actions.get(list));
            dispatch(actions.changePagination({total: result.total}));
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoading: false,
                }),
            );
        }
    };
};

// export const asyncGetAll = () => {
//     return async (dispatch, getState) => {
//         try {
//             dispatch(
//                 actions.changeUiStatus({
//                     isLoading: true,
//                 }),
//             );
//             // 下面的请求和结果返回需要根据接口来实现
//             let result = await request(clientUrl.getClientList, 'POST', {});
//             let { list } = result;
//             list = list.map(item => {
//                 item.key = item.clientId;
//                 return item;
//             });
//             dispatch(actions.getAll(list));
//         } catch (e) {
//             throw e;
//         } finally {
//             dispatch(
//                 actions.changeUiStatus({
//                     isLoading: false,
//                 }),
//             );
//         }
//     };
// };
// 重启
// export const reStart = params => {
//     return async (dispatch, getState) => {
//         try {
//             await request(clientUrl.restartClient, 'POST', params);
//             message.success('操作成功');
//         } catch (e) {
//             throw new Error(e);
//         }
//     };
// };

// export const asyncUpdate = content => {
//     return async (dispatch, getState) => {
//         try {
//             dispatch(actions.changeUiStatus({ isLoading: true }));
//             // 下面的请求和结果返回需要根据接口来实现
//             await request(clientUrl.setClient, 'POST', content);
//             message.success('修改成功');
//             dispatch(actions.changeUiStatus({isUpdateShow: false}));
//             // 下面的请求和结果返回需要根据接口来实现
//             let result = await request(clientUrl.getClientList, 'POST', formatGetParams(getState));
//             if (result) {
//                 dispatch(actions.get(result.list));
//                 dispatch(actions.changePagination({total: result.total}));
//             }
//         } catch (e) {
//             throw e;
//         } finally {
//             dispatch(actions.changeUiStatus({ isLoading: false }));
//         }
//     };
// };




// WEBPACK FOOTER //
// ./pages/monitor/thirdparty/reducers.js